import { useEffect, useState } from "react";

import { getBalance } from "../api/traceabilityApi";

export function useBalance(filters) {
  const { product, granularity, from_date, to_date } = filters;
  const requestKey = JSON.stringify({ product, granularity, from_date, to_date });
  const [result, setResult] = useState({ key: null, data: null, error: null });

  useEffect(() => {
    let live = true;
    getBalance({ product, granularity, from_date, to_date })
      .then((data) => live && setResult({ key: requestKey, data, error: null }))
      .catch((error) => live && setResult({ key: requestKey, data: null, error }));
    return () => {
      live = false;
    };
  }, [product, granularity, from_date, to_date, requestKey]);

  const isCurrentResult = result.key === requestKey;
  return {
    data: isCurrentResult ? result.data : null,
    loading: !isCurrentResult,
    error: isCurrentResult ? result.error : null,
  };
}
